import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import ApiKeys from "views/admin/apiKeys";
import Files from "views/admin/files";
import Billing from "views/admin/billing";
import TaskDetails from "views/admin/tasks/TaskDetails";

// Auth Imports
import SignIn from "views/auth/SignIn";
import SignOut from "views/auth/SignOut";

// Icon Imports
import {
  MdHome,
  MdLock,
  MdOutlineVpnKey,
  MdOutlineFolder,
  MdOutlineReceipt,
  MdViewList,
} from "react-icons/md";

const routes = [
  {
    name: "Home",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Task Details",
    layout: "/admin",
    path: "tasks/:taskId",
    icon: <MdViewList className="h-6 w-6" />,
    component: <TaskDetails />,
    secondary: true,
    hideInSidebar: true,
  },
  {
    name: "API Keys",
    layout: "/admin",
    path: "api-keys",
    icon: <MdOutlineVpnKey className="h-6 w-6" />,
    component: <ApiKeys />,
  },
  {
    name: "Files",
    layout: "/admin",
    path: "files",
    icon: <MdOutlineFolder className="h-6 w-6" />,
    component: <Files />,
  },
  {
    name: "Billing",
    layout: "/admin",
    path: "billing",
    icon: <MdOutlineReceipt className="h-6 w-6" />,
    component: <Billing />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Sign Out",
    layout: "/auth",
    path: "sign-out",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignOut />,
  },
];

export default routes;
